import { useContext, useMemo } from 'react';
import FilterPickerContext, {
  FilterPickerFilterFunction,
} from '../context/FilterPickerContext';

const useFilterPickerContext: <T = unknown>(
  parameterName: string
) => FilterPickerFilterFunction<T> | undefined = (parameterName: string) => {
  const context = useContext(FilterPickerContext);

  return useMemo(() => {
    return context[parameterName];
  }, [context, parameterName]);
};

export default useFilterPickerContext;
